import React from 'react';

import Welcome from '../components/Welcome';

const WelcomeContainer = () => <Welcome />;

export default WelcomeContainer;
